
import React, { useEffect, useState } from "react";
import Axios from 'services/BackendApi/BackendApi';
import { Button } from "react-bootstrap";
import FormElement from "common/components/FormElement/FormElement";

export default function CargaDocumentosFileView(props) {

  const [codigos, setCodigos] = useState([]);
  const [buscar, setBuscar] = useState([]);
  useEffect(() => {
    getReceptions();
  }, []);

  async function getReceptions() {
    const res = await Axios.receptionCodes({ urlParams: "1" });
    console.log(res);
    let aux = res.data.query_result.models_1.queryOneModel_1.result[0]
    let code =  aux.code;
    setBuscar(code);
    setCodigos(res.data.query_result.models_1.queryOneModel_1.result)

  }

  const handleShow = () => {
    console.log(buscar);
  };

  function handleCodigos(evc) {
    const newformDataCierre = { ...buscar };
    newformDataCierre[evc.target.name] = evc.target.value;
    setBuscar(newformDataCierre);
}

  return <div>
    <h1>BUSQUEDA POR RECEPCIÓN</h1>

    <FormElement label="Codigos" id="codigos" name="codigos" type="dropdown" onChange={handleCodigos} fieldLength={2}>
                {
                    codigos.map((reception, index) =>
                        <option value={reception.code} > {reception.code}</option>
                    )
                }
            </FormElement>
    <Button variant="primary" onClick={() => handleShow()} >Buscar</Button>
  </div>;

}